var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.09 469.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.4,290.07c-24.67,2.23-47.1,14.48-62.4,34.05l62.4,28.85v-62.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.69,290.09v59.65l51.39-37.29c-14.34-12.74-32.4-20.6-51.39-22.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.88,367.56l38.84,54.28h28.84c7.03-13.06,10.74-27.61,10.74-42.37,0-20.02-6.69-39.3-18.98-55.03l-59.44,43.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.06,337.93c-6.74,12.83-10.27,27.05-10.27,41.54,0,13.38,3.04,26.59,8.85,38.68l65.33-50.66-63.91-29.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.54,469.22c4.87,0,9.77-.43,14.85-1.34v-29.76h-82.69c16.9,19.69,41.34,31.09,67.84,31.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.69,463.49c14.1-5.25,26.74-14.03,36.61-25.36h-36.61v25.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.94,14.14c-1.15-3.14-2.18-6.04-3.09-8.67C14.37,1.23,9.72-.99,5.47.44,1.23,1.93-1.02,6.57.45,10.82c.94,2.72,2.01,5.7,3.19,8.92,1.21,3.3,4.33,5.35,7.65,5.35.93,0,1.88-.16,2.81-.5,4.22-1.55,6.39-6.23,4.84-10.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.62.45c-4.26-1.48-8.89.75-10.37,5.01-.92,2.63-1.95,5.54-3.1,8.68-1.55,4.22.61,8.9,4.85,10.45.92.34,1.87.5,2.8.5,3.32,0,6.44-2.05,7.65-5.35,1.19-3.23,2.24-6.2,3.18-8.91,1.48-4.24-.75-8.89-5.01-10.37Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.02,34.45c-4.1-1.79-8.92.1-10.71,4.22-18.27,42.04-51.56,100.8-106.48,142-26.21,19.66-54.7,33.36-84.74,40.93-4.09-11.32-14.84-19.48-27.54-19.48s-23.46,8.16-27.55,19.48c-30.04-7.56-58.52-21.26-84.74-40.93C80.35,139.47,47.05,80.71,28.78,38.67c-1.79-4.12-6.59-6.04-10.72-4.22-4.13,1.79-6.02,6.59-4.23,10.71,19.06,43.84,53.89,105.2,111.64,148.53,28.82,21.62,60.26,36.49,93.49,44.42,2.4,10.36,10.29,18.54,20.43,21.49v30.1h16.29v-30.1c10.14-2.95,18.03-11.13,20.42-21.49,33.24-7.93,64.68-22.79,93.49-44.42,57.77-43.33,92.6-104.69,111.64-148.53,1.79-4.13-.1-8.92-4.22-10.71ZM247.54,244.6c-7.22,0-13.1-5.88-13.1-13.09s5.88-13.1,13.1-13.1,13.09,5.88,13.09,13.1-5.88,13.09-13.09,13.09Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.46 421.84 277.68 421.84 245.85 377.34 188.46 421.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPend2);
export default __webpack_public_path__ + "static/media/icon_pend_2.e19143274da1a74066aa721fc479cf39.svg";
export { ForwardRef as ReactComponent };